module.exports = __webpack_public_path__ + "img/process_4.41e25941.png";